import { Map } from "immutable";
import { requestUpdate } from "../../../../services/ChangeService";
import { OffsetPoint } from "../../math/OffsetPoint";
const getHexKey = (hex) => OffsetPoint.toCacheKey(OffsetPoint.create(hex.offsetCoords));
export const useHexMapModel = ({ hexmap, onChange }) => {
    const model = hexmap.data;
    const addToModel = (changeLabel, hexes) => {
        const hexModelFragment = Map(hexes.map(h => [OffsetPoint.toCacheKey(h.offsetCoords), h])).toJS();
        const data = { ...model, ...hexModelFragment };
        onChange(requestUpdate({ changeLabel, resource: { ...hexmap, data } }));
    };
    const removeFromModel = (changeLabel, hexes) => {
        const data = { ...model };
        hexes.forEach((hex) => { delete data[getHexKey(hex)]; });
        onChange(requestUpdate({ changeLabel, resource: { ...hexmap, data } }));
    };
    return [model, addToModel, removeFromModel];
};
//# sourceMappingURL=hexMapModel.js.map